import { Col, Container, Row, Stack } from "react-bootstrap"

const HireAndroidDeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Expert Android Developers to Build High-Performance Mobile Apps
                        </h2>
                        <p>
                            Looking to create a robust, scalable, and user-friendly Android app? Our skilled Android developers turn your ideas into powerful mobile solutions tailored to meet your business goals and delight your users.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire Android Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>Custom Android App Development</b>
                                <p>
                                    We develop tailor-made Android apps that match your vision, business logic, and user needs — from concept to deployment.
                                </p>
                            </li>
                            <li>
                                <b>Latest Tech Stack & Tools</b>
                                <p>
                                    Our developers use modern tools like Kotlin, Java, Android Jetpack, and Firebase to build secure and high-performing apps.
                                </p>
                            </li>
                            <li>
                                <b>Performance & Compatibility Optimization</b>
                                <p>
                                    Your app will run smoothly across a wide range of Android devices and OS versions, ensuring maximum reach and reliability.
                                </p>
                            </li>
                            <li>
                                <b>Play Store Deployment & Support</b>
                                <p>
                                    We help with publishing your app to the Google Play Store and offer ongoing support, updates, and maintenance post-launch.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Models</b>
                                <p>
                                    Choose the engagement model that fits your needs — hire Android developers on a full-time, part-time, or hourly basis.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our Android Development Services
                        </h2>
                        <ul>
                            <li>Custom Android App Development</li>
                            <li>UI/UX Design for Android</li>
                            <li>Kotlin & Java-Based Development</li>
                            <li>API Integration & Backend Development</li>
                            <li>Google Play Store Deployment</li>
                            <li>Maintenance & App Upgrades</li>
                            <li>App Testing & Quality Assurance</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Let’s Build a Scalable Android App Together
                        </h2>
                        <p>
                            From startups to enterprises, we deliver Android solutions that solve real-world problems and drive business results. Talk to us today and get a free consultation with our Android development experts.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireAndroidDeveloperContent;
